import {
  getRedeemRequests as getRedeemRequestsApi,
  approveRedeemRequest as approveRedeemRequestApi,
  rejectRedeemRequest as rejectRedeemRequestApi,
  lookupRedeemApi,
} from "../utils/AxiosUtil";
import type {
  RedeemRequest,
  ApproveRedeemPayload,
  RejectRedeemPayload,
} from "../types/redeem";
import type { NetworkType } from "../utils/network";

async function getRedeemRequests(
  treasuryId: string,
  network: NetworkType,
  token?: string,
): Promise<RedeemRequest[]> {
  try {
    const data = await getRedeemRequestsApi(treasuryId, network, token);
    return data as RedeemRequest[];
  } catch (error: any) {
    console.log(`redeem_services => getRedeemRequests error:`, error);
    throw new Error("Failed to fetch redeem requests");
  }
}

async function approveRedeem(
  payload: ApproveRedeemPayload,
  network: NetworkType,
): Promise<void> {
  try {
    await approveRedeemRequestApi(payload, network);
  } catch (error: any) {
    console.log(`redeem_services => approveRedeem error:`, error);
    throw error;
  }
}

async function rejectRedeem(
  payload: RejectRedeemPayload,
  network: NetworkType,
): Promise<void> {
  try {
    await rejectRedeemRequestApi(
      {
        ...payload,
        stripeTxId: "rejected",
        success: false,
      },
      network,
    );
  } catch (error: any) {
    console.log(`redeem_services => rejectRedeem error:`, error);
    throw error;
  }
}

// A definitive miss comes back as 400 (the contract reports an unknown id as a zeroed struct),
// so it resolves to `null`; every other failure throws, and must never be shown as "no such
// redeem" — the operator would read an unreachable chain as proof the request doesn't exist.
async function lookupRedeem(
  requestId: string,
  network: NetworkType,
): Promise<RedeemRequest | null> {
  try {
    const res = await lookupRedeemApi(requestId, network);
    const redeem = res.data as RedeemRequest | undefined;
    return redeem?.id ? redeem : null;
  } catch (error: any) {
    if (error?.response?.status === 400) return null;
    console.log(`redeem_services => lookupRedeem error:`, error);
    throw new Error("Failed to fetch redeem request");
  }
}

const redeem_services = {
  getRedeemRequests,
  approveRedeem,
  rejectRedeem,
  lookupRedeem,
};
export default redeem_services;
